declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

export const META_PIXEL_ID = '874816958962530'

let initialized = false

/**
 * Injects the Meta Pixel base code, initializes the pixel and fires the
 * initial PageView event. Safe to call multiple times — it only runs once.
 */
export function initMetaPixel(pixelId: string = META_PIXEL_ID): void {
  if (typeof window === 'undefined' || initialized) return /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq?.('init', pixelId)
  window.fbq?.('track', 'PageView')
  initialized = true
}

/**
 * Fires a standard Meta Pixel event (e.g. "AddToCart").
 */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', event, params)
}
